


import React from 'react';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from "react-toastify";

import './index.css';
import { Provider } from 'react-redux';
import { store } from './Store/index';
// 🔴 MUST BE FIRST LINE — BEFORE ANY IMPORTS
const resizeObserverErr = /ResizeObserver loop completed with undelivered notifications/;

window.addEventListener("error", (event) => {
  if (resizeObserverErr.test(event.message)) {
    event.stopImmediatePropagation();
  }
});




const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
     <Provider store={store}>
    <ToastContainer/>
      <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
